import { Col, Input, Label, Row } from "reactstrap";
import Select from "react-select";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import sidebar from "../../utils/sidebar";
import SelectCustomStyles from "../../../../utils/styles/reactSelect";
import FixedSave from "../../../../components/Actions/FixedSave";
import { useEffect, useState } from "react";
import { get, post } from "../../../../utils/helpers/api";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomSelect from "../../../../components/Forms/CustomSelect";

function CreateCallPage() {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [initLoading, setInitLoading] = useState(true);
  const [saveLoading, setSaveLoading] = useState(false);
  const [employeesData, setEmployeesData] = useState([]);
  const [callData, setCallData] = useState({
    customer: state?.callData?.customer || null,
    customer_id: state?.callData?.customer_id || "",
    employee_id: state?.callData?.employee_id || null,
    lead: state?.callData?.lead || null,
    lead_id: state?.callData?.lead_id || null,
    call_for: state?.callData?.call_for || 'customer',
    call_type: state?.callData?.call_type || 'inbound',
    call_start_time: state?.callData?.call_start_time || null,
    call_duration: state?.callData?.call_duration || null,
    subject: state?.callData?.subject || '',
    call_purpose: state?.callData?.call_purpose || '',
    purpose_description: state?.callData?.purpose_description || '',
    call_result: state?.callData?.call_result || '',
    outcome_description: state?.callData?.outcome_description || ''
  });

  useEffect(() => {
    initData();
  }, []);

  const initData = async () => {
    setInitLoading(true);
    const data = await get('/crm/calls/create');
    if (data.success) {
      setEmployeesData(data.employees);
      setInitLoading(false);
    }
  };

  const saveCall = async () => {
    setSaveLoading(true);
    const url = id ? '/crm/calls/update/' + id : '/crm/calls/store';
    const data = await post(url, { ...callData });
    if (data.success) {
      navigate('/crm/calls/view/' + data.call.id, { state: { callData: data.call } });
    } else {
      toast.error(data.message || t('common.somethingWentWrong'));
    }
    setSaveLoading(false);
  };

  return (
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader
          breadcrumb={[t('crm.calls'), id ? t('crm.editCall') : t('crm.newCall')]}
          onBack={() => navigate('/crm/calls')}
        />

        <div className="subheader-page-content scrollable">
          <h5 className="fw-bold mb-3">{t('crm.callInformation')}</h5>
          <Row className="mb-3">
            <Col xs="6" className="mb-3">
              <Label>{t('crm.callFor')} <span className="text-danger">*</span></Label>
              <Row className="g-1">
                <Col xs="4">
                  <Input type="select" value={callData.call_for} onChange={e => setCallData({ ...callData, call_for: e.target.value, customer_id: null, lead_id: null })}>
                    <option value="customer">{t('crm.customer')}</option>
                    <option value="lead">{t('crm.lead')}</option>
                  </Input>
                </Col>
                <Col xs="8">
                  {callData.call_for === 'customer' ? (
                    <CustomSelect
                      value={callData.customer || null}
                      onChange={selected => setCallData({ ...callData, customer: selected, customer_id: selected ? selected.value : null })}
                      module="crm/customers"
                      placeholder={t('crm.searchCustomerPlaceholder')}
                      createLink="/crm/customers/create"
                    />
                  ) : (
                    <CustomSelect
                      value={callData.lead || null}
                      onChange={selected => setCallData({ ...callData, lead: selected, lead_id: selected ? selected.value : null })}
                      module="crm/leads"
                      placeholder={t('crm.searchLeadPlaceholder')}
                      createLink="/crm/leads/create"
                    />
                  )}
                </Col>
              </Row>
            </Col>
            <Col xs="6" className="mb-3">
              <Label>{t('crm.relatedTo')} </Label>
              <Select
                options={employeesData.map(e => ({ value: e.id, label: e.firstname + ' ' + e.lastname }))}
                styles={SelectCustomStyles}
                value={employeesData.map(e => ({ value: e.id, label: e.firstname + ' ' + e.lastname })).find(o => o.value === callData.employee_id) || null}
                onChange={selected => setCallData({ ...callData, employee_id: selected ? selected.value : null })}
              />
            </Col>
            <Col xs="6" className="mb-3">
              <Label>{t('crm.callType')} </Label>
              <Input type="select" value={callData.call_type} onChange={e => setCallData({ ...callData, call_type: e.target.value })}>
                <option value="inbound">{t('crm.inbound')}</option>
                <option value="outbound">{t('crm.outbound')}</option>
                <option value="missed">{t('common.missed')}</option>
              </Input>
            </Col>
            <Col xs="6" className="mb-3">
              <Label>{t('crm.callStartTime')} </Label>
              <Input
                type="datetime-local"
                value={callData.call_start_time ? callData.call_start_time.substring(0, 16) : ''}
                onChange={e => setCallData({ ...callData, call_start_time: e.target.value })}
              />
            </Col>
            <Col xs="6" className="mb-3">
              <Label>{t('crm.callDuration')} </Label>
              <Input
                type="number"
                value={callData.call_duration || ''}
                onChange={e => setCallData({ ...callData, call_duration: e.target.value })}
              />
            </Col>
            <Col xs="6" className="mb-3">
              <Label>{t('common.subject')}: </Label>
              <Input
                type="text"
                value={callData.subject || ''}
                onChange={e => setCallData({ ...callData, subject: e.target.value })}
              />
            </Col>
          </Row>

          <h5 className="fw-bold mb-3">{t('crm.purposeOfCall')}</h5>
          <Row>
            <Col md="6" xs="12" className="mb-3">
              <Label>{t('crm.callPurpose')} </Label>
              <CustomSelect
                value={callData.call_purpose}
                onChange={(selected, objectData) => setCallData({ ...callData, call_purpose: selected ? selected.label : '' })}
                module="crm/settings/call-purposes"
                placeholder={t('crm.searchPurposePlaceholder')}
                createLink="/crm/settings"
                responseKey="call_purposes"
                canCreate
              />
            </Col>
            <Col md="6" xs="12" className="mb-3">
              <Label>{t('common.description')}: </Label>
              <Input
                type="textarea"
                value={callData.purpose_description || ''}
                onChange={e => setCallData({ ...callData, purpose_description: e.target.value })}
              />
            </Col>
          </Row>

          <h5 className="fw-bold mb-3">{t('crm.outgoingCallStatus')}</h5>
          <Row>
            <Col md="6" xs="12" className="mb-3">
              <Label>{t('crm.callResult')} </Label>
              <CustomSelect
                value={callData.call_result}
                onChange={(selected, objectData) => setCallData({ ...callData, call_result: selected ? selected.label : '' })}
                module="crm/settings/call-results"
                placeholder={t('crm.searchResultPlaceholder')}
                createLink="/crm/settings"
                responseKey="call_results"
                canCreate
              />
            </Col>
            <Col md="6" xs="12" className="mb-3">
              <Label>{t('common.description')}: </Label>
              <Input
                type="textarea"
                value={callData.outcome_description || ''}
                onChange={e => setCallData({ ...callData, outcome_description: e.target.value })}
              />
            </Col>
          </Row>
        </div>
      </div>

      <FixedSave 
        loading={saveLoading} 
        disabled={initLoading || saveLoading || (!callData?.customer_id && !callData?.lead_id)} 
        onSave={saveCall} 
      />
    </SidebarLayout>
  );
}

export default CreateCallPage;
